module.exports = __webpack_public_path__ + "assets/img/768_aboutus_img__colorsystem_2.dad257a9.svg";